
export const QuizAnswerView = ({answer, answerState='', answerLength=0, onAnswerReset=f=>f})=>{
    console.log(answer);
    return (
        <div className={`answer_area ${answerState}`}>
            {
                new Array(answerLength).fill("").map( (tmp, key)=>{
                    let text = '\u00A0 ';
                    
                    if(answer.length>key && !answer[key].disabled){
                        text = answer[key].content;
                    }
                    
                    return <div className={`answer`} key={key}>{text}</div>;
                })
            }
            <button type="button" className="btn_reset" onClick={onAnswerReset}><i className="icon fas fa-undo-alt"></i><span>초기화</span></button>
        </div>
    )
}